import { PredefinedChipOptions } from "@redotech/redo-model/customer-widget/customer-widget";
import * as z from "zod";
import { enum as zEnum } from "zod";
export const updateCustomerWidgetSettings = {
  name: "updateCustomerWidgetSettings" as const,
  input: z.object({
    widgetColor: z.string(),
    selectedPredefinedChips: z.array(zEnum(PredefinedChipOptions)),
    customChips: z.array(z.string()).optional(),
  }),
  output: z.null(),
};
